import React, { useEffect, useState } from "react";
import AppShell from "../../components/layout/AppShell";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Trophy, ArrowSquareOut, Coins, Wallet } from "@phosphor-icons/react";

export default function ReferralAffiliate() {
  const [summary, setSummary] = useState(null);
  const [perf, setPerf] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [s, p] = await Promise.all([
          api.get("/referrals/affiliate-summary"),
          api.get("/referrals/performance/customers"),
        ]);
        setSummary(s.data); setPerf(p.data);
      } catch (e) { toast.error(formatApiError(e)); }
    })();
  }, []);

  return (
    <AppShell title="Affiliate Program" subtitle="Customer-to-customer referrals · 10% reward on first package payment">
      {summary && (
        <div className="grid grid-cols-4 gap-4 mb-6" data-testid="aff-summary">
          <Stat label="Total Rewards" value={`₹${summary.rewards_total.toFixed(2)}`} sub={`${summary.rewards_count} credited`} icon={Trophy}/>
          <Stat label="Paid Out" value={`₹${summary.payouts_total.toFixed(2)}`} sub={`${summary.payouts_count} payouts`} icon={Coins}/>
          <Stat label="Outstanding" value={`₹${summary.outstanding.toFixed(2)}`} sub="Unpaid balance"/>
          <Stat label="Reward Rate" value={`${(summary.reward_pct*100).toFixed(0)}%`} sub={`Min payout ₹${summary.payout_min}`}/>
        </div>
      )}

      <div className="bg-white border border-[#E5E2D9] rounded-md overflow-hidden" data-testid="aff-table">
        <div className="px-5 py-3 border-b border-[#E5E2D9] flex items-center gap-2">
          <Wallet size={14}/>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#5C5A55]">Top referrers</div>
        </div>
        {perf.length === 0 ? (
          <div className="p-10 text-center text-sm text-[#8A8780]">No referral rewards yet — share customer links to start.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-[#F7F6F2] text-[10px] uppercase tracking-[0.2em] text-[#5C5A55]">
              <tr>
                <th className="text-left px-5 py-2.5">Customer</th>
                <th className="text-right px-3 py-2.5">Referrals</th>
                <th className="text-right px-3 py-2.5">Earned</th>
                <th className="text-right px-3 py-2.5">Paid</th>
                <th className="text-right px-3 py-2.5">Available</th>
                <th className="px-3 py-2.5"></th>
              </tr>
            </thead>
            <tbody>
              {perf.map(r => (
                <tr key={r.customer_id} className="border-t border-[#F0ECE3]">
                  <td className="px-5 py-3">
                    <div className="font-medium">{r.name}</div>
                    <div className="text-xs text-[#5C5A55] font-mono">{r.customer_code}</div>
                  </td>
                  <td className="px-3 py-3 text-right">{r.referrals}</td>
                  <td className="px-3 py-3 text-right font-mono">₹{r.total_earned.toFixed(2)}</td>
                  <td className="px-3 py-3 text-right font-mono text-[#5C5A55]">₹{r.total_paid.toFixed(2)}</td>
                  <td className="px-3 py-3 text-right font-mono text-[#2D5A27]">₹{r.available.toFixed(2)}</td>
                  <td className="px-3 py-3 text-right">
                    <Link to={`/customers/${r.customer_id}/rewards`} data-testid={`open-rewards-${r.customer_id}`}
                          className="inline-flex items-center gap-1 text-xs text-[#2D5A27] hover:underline">
                      open <ArrowSquareOut size={11}/>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </AppShell>
  );
}

const Stat = ({ label, value, sub, icon: I }) => (
  <div className="bg-white border border-[#E5E2D9] rounded-md p-4">
    <div className="flex items-center gap-2 mb-2">
      {I && <I size={14} className="text-[#2D5A27]"/>}
      <div className="text-[10px] uppercase tracking-[0.2em] text-[#5C5A55]">{label}</div>
    </div>
    <div className="text-2xl font-light text-[#2D2B26]">{value}</div>
    {sub && <div className="text-xs text-[#8A8780] mt-1">{sub}</div>}
  </div>
);
